import React, { Component } from "react";
import MessageList from "./MessageList";
import "./Styles/index.css";
class LiveChat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="live-chat-container">
        <MessageList logo="bolt" {...this.props} />
      </div>
    );
  }
}
export default LiveChat;



// WEBPACK FOOTER //
// ./src/screens/LiveChat/index.js